export default __webpack_public_path__ + "static/media/walletconnect.d89f2978.webp";